<template>
  <div class="user">
    <self-title :title="titles" :fixed="true" @titleClick="titleClick"></self-title>
    <transition name="slide-fade">
      <div class="main" v-show="web == 'main'">
        <div class="title">版本历史</div>
        <el-timeline>
          <el-timeline-item v-for="(item, index) in versions" :key="index" :timestamp="item.create_time" placement="top">
            <el-card>
              <h4>{{item.content}}</h4>
              <p>{{item.author}} 提交于 {{item.create_time}}</p>
              <p>版本号：{{item.version}}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </transition>
  </div>
</template>

<script>
// import selfTitle from '../components/Title'
export default {
  name: 'User',
  // components: {
  //   selfTitle
  // },
  data() {
    return {
      userInfo: {},
      titles: ['首页', '版本历史'],
      web: 'main',
      versions: []
    }
  },
  methods: {
    titleClick(item, index) {
      console.log(item, index)
      if (item === '首页') {
        this.$router.push({
          name: 'Home'
        })
        this.titles = ['首页'] // 导航菜单
      }
    },
    versionQuery(facet) {
      const param = {
        facet: facet
      }
      this.$get('/version/query', param).then(
        result => {
          if (result.status === 200) {
            this.versions = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    }
  },
  mounted() {
    this.versionQuery('A')
  },
  beforeDestroy() {}
}
</script>

<style lang="less" scoped>
.user {
  padding: 2vh 2vw 0;
  .title {
    height: 3vh;
    line-height: 3vh;
    font-size: 1.5rem;
    margin-bottom: 1.4vh;
  }
}
</style>
